import { BackgroundJobsProvider } from './background-jobs.context';
import { BreadcrumbOverrideProvider } from './breadcrumb-override.context';
import { FeedbackPanelProvider } from './feedback-panel.context';
import { HeaderTitleProvider } from './header-title.context';
import { SpreadsheetProvider } from './spreadsheet/spreadsheet.context';
import { ViewModeProvider } from './view-mode.context';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <ViewModeProvider>
      <SpreadsheetProvider>
        <BackgroundJobsProvider>
          <BreadcrumbOverrideProvider>
            <HeaderTitleProvider>
              <FeedbackPanelProvider>{children}</FeedbackPanelProvider>
            </HeaderTitleProvider>
          </BreadcrumbOverrideProvider>
        </BackgroundJobsProvider>
      </SpreadsheetProvider>
    </ViewModeProvider>
  );
}
